import { getSearchParameters } from 'error-handler/helper/utils';

import config from 'error-handler/config';
import { store } from 'redux/store';

import admin from 'error-handler/functions/send/admin';
import telegram from 'error-handler/functions/send/telegram';
import { include } from 'utils/helpers/functions';

interface IMeta {
  Function?: string;
  Component?: string;
  Line?: number;
  Author?: string;
  errorInfo?: string;
}

export interface IErrorData {
  error: any;
  errorInfo?: any;
  funcName?: string;
  metaInfo?: IMeta;
}

const sendError = async (errorData: IErrorData, fn?: (state: string) => void): Promise<void> => {
  const queryParams: any = getSearchParameters();
  if (queryParams.gclid) return;

  const { error, errorInfo } = errorData;
  if (include(error.toString(), '403')) return;

  const logs = store.getState().logData.logs.reverse().slice(0, 15).reverse();
  const stack = error.toString().split(' in ')[0];
  const locations = errorInfo
    ? `
${errorInfo.componentStack.split(' in ')[0]}
${errorInfo.componentStack.split(' in ')[1] ?? ''}
${errorInfo.componentStack.split(' in ')[2] ?? ''}`.trim()
    : null;

  const message = `${stack}
${locations ? `Location: ${locations}` : ''}`.trim();

  if (config.isSendTelegram) await telegram(errorData, logs, message);
  if (config.isSendAdmin) await admin(errorData, logs);

  fn && fn(message);
};

export default sendError;
